// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_0fce717cdb--checkbox--3UOtu","handler":"_0fce717cdb--handler--3jbd5","box":"_0fce717cdb--box--1GvbR","hidden_input":"_0fce717cdb--hidden_input--c8sDd"};